/**
 * Furrend Atlas — curated story pins.
 * year = when the story “belongs” on the timeline (not always birth year)
 * face = optional local image path (fallback); Parcel-resolved URLs live in atlas-faces.js
 * Prefer circular animal cutouts in assets/images/atlas/pins/{id}.png when available.
 */
window.ATLAS_ENTRIES = [
  {
    id: "top-wombat",
    name: "Top",
    blurb: "The wombat who wandered Rossetti’s London sitting rooms",
    place: "Chelsea, London",
    lat: 51.4875,
    lng: -0.1687,
    year: 1869,
    url: "https://furrend.xyz/blog/story-archive/rossetti-and-the-wombat",
    face: "../assets/images/rossetti_and_the_wombat.png",
  },
  {
    id: "owney",
    name: "Owney",
    blurb: "The postal dog who rode the rails across America and beyond",
    place: "Albany, New York",
    lat: 42.6526,
    lng: -73.7562,
    year: 1888,
    url: "https://furrend.xyz/blog/story-archive/owney-the-postal-dog",
    face: "../assets/images/owney_the_postal_dog.png",
  },
  {
    id: "roxy",
    name: "Roxy",
    blurb: "The kitten found in stolen goods who became Denver’s police cat",
    place: "Denver, Colorado",
    lat: 39.7392,
    lng: -104.9903,
    year: 1891,
    url: "https://furrend.xyz/blog/story-archive/roxy-the-denver-police-cat",
    face: "../assets/images/roxy_the_cat.png",
  },
  {
    id: "josiah",
    name: "Josiah",
    blurb: "The White House badger who bit legs, never faces",
    place: "Washington, D.C.",
    lat: 38.8977,
    lng: -77.0365,
    year: 1903,
    url: "https://furrend.xyz/blog/story-archive/josiah-the-badger-who-lived-in-the-white-house",
    face: "../assets/images/josiah_the_badger.png",
  },
  {
    id: "winnie",
    name: "Winnie",
    blurb: "The real bear behind Winnie-the-Pooh",
    place: "London Zoo",
    lat: 51.5353,
    lng: -0.1535,
    year: 1914,
    url: "https://furrend.xyz/blog/story-archive/the-bear-behind-winnie-the-pooh",
    face: "../assets/images/atlas/winnie-the-pooh.png",
  },
  {
    id: "cher-ami",
    name: "Cher Ami",
    blurb: "The pigeon who saved nearly 200 lives of the Lost Battalion",
    place: "Argonne Forest, France",
    lat: 49.2,
    lng: 5.0,
    year: 1918,
    url: "https://furrend.xyz/blog/cher-ami-and-the-lost-battalion",
    face: "../assets/images/cher_ami.png",
  },
  {
    id: "rin-tin-tin",
    name: "Rin Tin Tin",
    blurb: "The silent-film dog who helped save Warner Bros.",
    place: "Los Angeles, California",
    lat: 34.0928,
    lng: -118.3287,
    year: 1923,
    url: "https://furrend.xyz/blog/rin-tin-tin-the-silent-film-dog-who-saved-warner-bros",
    face: "../assets/images/rin-tin-tin.png",
  },
  {
    id: "bobbie",
    name: "Bobbie",
    blurb: "The wonder dog who walked home across America",
    place: "Silverton, Oregon",
    lat: 45.0051,
    lng: -122.7832,
    year: 1923,
    url: "https://furrend.xyz/blog/story-archive/bobbie-the-wonder-dog-who-crossed-america",
    face: "../assets/images/bobbie_the_wonder_dog.webp",
  },
  {
    id: "algonquin",
    name: "Algonquin cats",
    blurb: "A century of lobby cats; there should always be a cat here",
    place: "New York City",
    lat: 40.761,
    lng: -73.9819,
    year: 1923,
    url: "https://furrend.xyz/blog/there-should-always-be-a-cat-here",
    face: "../assets/images/algonquin_hamlet.webp",
  },
  {
    id: "minnie-white-city",
    name: "Minnie",
    blurb: "White City Stadium’s record-setting ratter",
    place: "London, England",
    lat: 51.5135,
    lng: -0.2275,
    year: 1927,
    url: "https://furrend.xyz/blog/story-archive/white-city-stadium-had-a-cat-for-the-rats",
    face: "../assets/images/minnie_the_cat.png",
  },
  {
    id: "jim-wonder",
    name: "Jim",
    blurb: "The Missouri wonder dog who seemed to understand anything",
    place: "Marshall, Missouri",
    lat: 39.1231,
    lng: -93.1969,
    year: 1931,
    url: "https://furrend.xyz/blog/story-archive/jim-the-wonder-dog",
    face: "../assets/images/jim_the_wonder_dog.png",
  },
  {
    id: "sinbad",
    name: "Sinbad",
    blurb: "The Coast Guard’s Chief Dog who served 11 years aboard Campbell",
    place: "Staten Island, New York",
    lat: 40.5795,
    lng: -74.1502,
    year: 1937,
    url: "https://furrend.xyz/blog/story-archive/sinbad-the-coast-guards-chief-dog",
    face: "../assets/images/atlas/sinbad.png",
  },
  {
    id: "comet",
    name: "Comet",
    blurb: "The elephant who waited tables in Piccadilly Circus",
    place: "London, England",
    lat: 51.5099,
    lng: -0.1342,
    year: 1938,
    url: "https://furrend.xyz/blog/story-archive/comet-the-elephant",
    face: "../assets/images/comet_the_elephant.png",
  },
  {
    id: "ming",
    name: "Ming",
    blurb: "London’s wartime panda who gladdened the universal heart",
    place: "London Zoo",
    lat: 51.5353,
    lng: -0.1535,
    year: 1938,
    url: "https://furrend.xyz/blog/story-archive/ming-londons-wartime-panda",
    face: "../assets/images/ming_the_panda.png",
  },
  {
    id: "snooky",
    name: "Snooky",
    blurb: "New York City Hall’s unofficial feline resident",
    place: "New York City",
    lat: 40.7128,
    lng: -74.006,
    year: 1939,
    url: "https://furrend.xyz/blog/story-archive/snooky-of-city-hall",
    face: "../assets/images/snooky_of_city_hall.png",
  },
  {
    id: "tommy-tucker",
    name: "Tommy Tucker",
    blurb: "The New York cat briefly left $5,000 in a will",
    place: "New York City",
    lat: 40.7903,
    lng: -73.9698,
    year: 1939,
    url: "https://furrend.xyz/blog/story-archive/tommy-tucker-and-the-5000-problem",
    face: "../assets/images/tommy_tucker_the_cat.png",
  },
  {
    id: "reindeer-rockefeller",
    name: "Rockefeller reindeer",
    blurb: "Four live “reindeer” in the plaza days after Pearl Harbor",
    place: "New York City",
    lat: 40.7587,
    lng: -73.9787,
    year: 1941,
    url: "https://furrend.xyz/blog/story-archive/the-reindeer-christmas-at-rockefeller-center-in-1941",
    face: "../assets/images/the_reindeer_christmas_in_nyc.png",
  },
  {
    id: "unsinkable-sam",
    name: "Unsinkable Sam",
    blurb: "The ship’s cat who survived 3 sinkings",
    place: "North Atlantic",
    lat: 48.0,
    lng: -20.0,
    year: 1941,
    url: "https://furrend.xyz/blog/story-archive/unsinkable-sam-the-ships-cat-who-survived-three-sinkings",
    face: "../assets/images/unsinkable_sam.png",
  },
  {
    id: "andrew",
    name: "Andrew",
    blurb: "London’s air-raid cat who took cover before the bombs",
    place: "London, England",
    lat: 51.5074,
    lng: -0.1278,
    year: 1941,
    url: "https://furrend.xyz/blog/story-archive/andrew-the-london-air-raid-cat-of-world-war-2",
    face: "../assets/images/andrew_the_cat.png",
  },
  {
    id: "bush",
    name: "Flying Officer Bush",
    blurb: "The RAF dog who waited for pilots to come home",
    place: "England",
    lat: 52.2,
    lng: -0.8,
    year: 1941,
    url: "https://furrend.xyz/blog/story-archive/flying-officer-bush",
    face: "../assets/images/flying_officer_bush.png",
  },
  {
    id: "beauty",
    name: "Beauty",
    blurb: "One of the first Blitz search-and-rescue dogs",
    place: "London, England",
    lat: 51.52,
    lng: -0.15,
    year: 1941,
    url: "https://furrend.xyz/blog/story-archive/beauty-the-rescue-dog-of-the-london-blitz",
    face: "../assets/images/beauty_the_rescue_dog.webp",
  },
  {
    id: "convoy",
    name: "Convoy",
    blurb: "The ship’s cat with his own hammock on HMS Hermione",
    place: "Mediterranean",
    lat: 35.5,
    lng: 18.0,
    year: 1941,
    url: "https://furrend.xyz/blog/story-archive/convoy-the-ships-cat-of-hms-hermione",
    face: "../assets/images/convoy_the_ships_cat.webp",
  },
  {
    id: "jackie",
    name: "Jackie",
    blurb: "The Finnish dog the Nazis investigated for “insulting Hitler”",
    place: "Tampere, Finland",
    lat: 61.4978,
    lng: 23.761,
    year: 1941,
    url: "https://furrend.xyz/blog/story-archive/the-nazis-investigated-a-dog-named-jackie",
    face: "../assets/images/jackie_the_dog.webp",
  },
  {
    id: "wojtek",
    name: "Wojtek",
    blurb: "The soldier bear who carried ammo at Monte Cassino",
    place: "Monte Cassino, Italy",
    lat: 41.4901,
    lng: 13.8139,
    year: 1944,
    url: "https://furrend.xyz/blog/wojtek-the-soldier-bear",
    face: "../assets/images/wojtek-the-soldier-bear.png",
  },
  {
    id: "pyro",
    name: "Pyro",
    blurb: "The flying cat who warmed an RAF photographer’s hands",
    place: "Helensburgh, Scotland",
    lat: 56.0042,
    lng: -4.7327,
    year: 1942,
    url: "https://furrend.xyz/blog/story-archive/pyro-the-flying-cat",
    face: "../assets/images/pyro_the_flying_cat.png",
  },
  {
    id: "herman",
    name: "Herman",
    blurb: "The Coast Guard Expert Mouser of Baltimore’s docks",
    place: "Baltimore, Maryland",
    lat: 39.2904,
    lng: -76.6122,
    year: 1943,
    url: "https://furrend.xyz/blog/story-archive/herman-the-cat-expert-mouser",
    face: "../assets/images/herman_the_cat.png",
  },
  {
    id: "lady-moe",
    name: "Lady Moe",
    blurb: "The flying donkey who crossed from Algeria to England",
    place: "England",
    lat: 52.1,
    lng: 0.5,
    year: 1943,
    url: "https://furrend.xyz/blog/story-archive/lady-moe-the-flying-donkey",
    face: "../assets/images/lady_moe_the_donkey.png",
  },
  {
    id: "siwash",
    name: "Sergeant Siwash",
    blurb: "The Marine Corps “devil duck” of the Pacific",
    place: "Tarawa",
    lat: 1.35,
    lng: 172.98,
    year: 1943,
    url: "https://furrend.xyz/blog/story-archive/sergeant-siwash",
    face: "../assets/images/sergeant_siwash.png",
  },
  {
    id: "spar",
    name: "Spar",
    blurb: "The Coast Guard dog in dress blues",
    place: "North Atlantic",
    lat: 50.0,
    lng: -25.0,
    year: 1943,
    url: "https://furrend.xyz/blog/story-archive/spar-the-coast-guard-dog-in-dress-blues",
    face: "../assets/images/spar_the_dog.png",
  },
  {
    id: "judy",
    name: "Judy",
    blurb: "The only dog officially registered as a prisoner of war",
    place: "Medan, Sumatra",
    lat: 3.5952,
    lng: 98.6722,
    year: 1942,
    url: "https://furrend.xyz/blog/story-archive/judy-pow81a-the-only-dog-prisoner-of-war",
    face: "../assets/images/judy.png",
  },
  {
    id: "dee-day",
    name: "Dee-Day",
    blurb: "The Coast Guard kitten who crossed to Normandy",
    place: "Normandy, France",
    lat: 49.4,
    lng: -0.9,
    year: 1944,
    url: "https://furrend.xyz/blog/story-archive/dee-day",
    face: "../assets/images/dee_day_the_cat.png",
  },
  {
    id: "bing",
    name: "Bing",
    blurb: "The paradog who jumped into Normandy on D-Day",
    place: "Normandy, France",
    lat: 49.25,
    lng: -0.7,
    year: 1944,
    url: "https://furrend.xyz/blog/story-archive/bing-who-jumped-into-normandy",
    face: "../assets/images/bing_the_dog.png",
  },
  {
    id: "pooli",
    name: "Pooli",
    blurb: "The Navy cat born on the Fourth of July at Pearl Harbor",
    place: "Pearl Harbor, Hawaii",
    lat: 21.3445,
    lng: -157.9749,
    year: 1944,
    url: "https://furrend.xyz/blog/story-archive/pooli-born-on-the-fourth-of-july",
    face: "../assets/images/pooli_the_cat.png",
  },
  {
    id: "myrtle",
    name: "Myrtle",
    blurb: "The parachick who earned her wings before Arnhem",
    place: "Arnhem, Netherlands",
    lat: 51.9851,
    lng: 5.8987,
    year: 1944,
    url: "https://furrend.xyz/blog/story-archive/myrtle-the-parachick",
    face: "../assets/images/myrtle_the_parachick.webp",
  },
  {
    id: "private-life-cat",
    name: "The Private Life of a Cat",
    blurb: "A 1940s film that feels like the first viral cat video",
    place: "New York City",
    lat: 40.7282,
    lng: -73.9942,
    year: 1945,
    url: "https://furrend.xyz/blog/the-private-life-of-a-cat",
    face: "../assets/images/the-private-life-of-a-cat-furrend.png",
  },
  {
    id: "kiri-many",
    name: "Kiri and Many",
    blurb: "The circus elephants who cleared bomb damage in Hamburg",
    place: "Hamburg, Germany",
    lat: 53.5511,
    lng: 9.9937,
    year: 1945,
    url: "https://furrend.xyz/blog/story-archive/kiri-and-many-the-elephants-who-cleared-hamburg",
    face: "../assets/images/kiri_many.webp",
  },
  {
    id: "carl",
    name: "Carl",
    blurb: "The Chicago firehouse dog who never missed a fire call",
    place: "Chicago, Illinois",
    lat: 41.8781,
    lng: -87.6298,
    year: 1947,
    url: "https://furrend.xyz/blog/story-archive/carl-the-dog-who-never-missed-a-fire-call",
    face: "../assets/images/carl_the_firehouse_dog_of_chicago.webp",
  },
  {
    id: "simon",
    name: "Simon",
    blurb: "The only cat awarded the Dickin Medal",
    place: "Yangtze River, China",
    lat: 32.0,
    lng: 118.8,
    year: 1949,
    url: "https://furrend.xyz/blog/story-archive/simon-the-ships-cat",
    face: "../assets/images/simon_the_ships_cat.png",
  },
  {
    id: "koo-koo",
    name: "Koo Koo",
    blurb: "The charity seal who fundraised in a Lincolnshire pub",
    place: "Boston, Lincolnshire",
    lat: 52.9789,
    lng: -0.0266,
    year: 1948,
    url: "https://furrend.xyz/blog/story-archive/kookoo-the-charity-seal-of-the-cross-keys-pub",
    face: "../assets/images/kookoo_the_seal.webp",
  },
  {
    id: "reckless",
    name: "Sergeant Reckless",
    blurb: "The Korean War horse who carried ammo under fire",
    place: "Outpost Vegas, Korea",
    lat: 38.2,
    lng: 127.0,
    year: 1953,
    url: "https://furrend.xyz/blog/story-archive/reckless-the-horse-who-carried-more-than-ammunition",
    face: "../assets/images/sergeant_reckless.webp",
  },
  {
    id: "tibs",
    name: "Tibs the Great",
    blurb: "Britain’s legendary Post Office cat",
    place: "London, England",
    lat: 51.5155,
    lng: -0.0922,
    year: 1950,
    url: "https://furrend.xyz/blog/story-archive/tibs-the-great-britains-post-office-cat",
    face: "../assets/images/tibs_the_great.webp",
  },
  {
    id: "smokey-bear",
    name: "Smokey Bear",
    blurb: "The rescued cub who became America’s wildfire prevention icon",
    place: "Capitan, New Mexico",
    lat: 33.5453,
    lng: -105.5953,
    year: 1950,
    url: "https://furrend.xyz/blog/story-archive/the-bear-who-became-smokey-bear",
    face: "../assets/images/smokey_bear.webp",
  },
  {
    id: "gardenia",
    name: "Gardenia",
    blurb: "The Louisiana library cat who retired on a satin pillow",
    place: "Ouachita Parish, Louisiana",
    lat: 32.5093,
    lng: -92.1193,
    year: 1952,
    url: "https://furrend.xyz/blog/story-archive/gardenia-the-library-cat-of-louisiana",
    face: "../assets/images/gardenia_the_library_cat.webp",
  },
  {
    id: "branca-cat",
    name: "Branca’s black cat",
    blurb: "Friday the 13th luck at Ebbets Field",
    place: "Brooklyn, New York",
    lat: 40.655,
    lng: -73.96,
    year: 1951,
    url: "https://furrend.xyz/blog/story-archive/ralph-branca-a-black-cat-and-friday-the-13th",
    face: "../assets/images/ralph_branca_the_black_cat.png",
  },
  {
    id: "buddy-deaf",
    name: "Buddy",
    blurb: "The deaf dog who took the stage across Kansas",
    place: "Olathe, Kansas",
    lat: 38.8814,
    lng: -94.8191,
    year: 1951,
    url: "https://furrend.xyz/blog/story-archive/buddy-the-deaf-dog-who-took-the-stage",
    face: "../assets/images/buddy_the_deaf_dog.webp",
  },
  {
    id: "room-8",
    name: "Room 8",
    blurb: "The school cat of Elysian Heights Elementary",
    place: "Los Angeles, California",
    lat: 34.078,
    lng: -118.26,
    year: 1952,
    url: "https://furrend.xyz/room-8",
    face: "../assets/images/room-8/hewett-3.webp",
  },
  {
    id: "jet",
    name: "Jet",
    blurb: "The rat-catching Labrador who could also pull pints",
    place: "Preston, England",
    lat: 53.7632,
    lng: -2.7031,
    year: 1953,
    url: "https://furrend.xyz/blog/story-archive/jet-the-rat-catching-dog-who-learned-to-pull-pints",
    face: "../assets/images/jet_the_dog.webp",
  },
  {
    id: "opo",
    name: "Opo",
    blurb: "The friendly dolphin who adopted a New Zealand town",
    place: "Opononi, New Zealand",
    lat: -35.507,
    lng: 173.391,
    year: 1955,
    url: "https://furrend.xyz/blog/story-archive/opo-the-friendly-dolphin-of-opononi",
    face: "../assets/images/opo_the_dolphin.png",
  },
  {
    id: "takeshi",
    name: "Takeshi",
    blurb: "The calico cat who overwintered in Antarctica",
    place: "Antarctica",
    lat: -69.0,
    lng: 39.5,
    year: 1956,
    url: "https://furrend.xyz/blog/story-archive/takeshi-the-cat-who-went-south",
    face: "../assets/images/atlas/takeshi.png",
  },
  {
    id: "laika",
    name: "Laika",
    blurb: "The first living creature to orbit Earth",
    place: "Moscow, USSR",
    lat: 55.7558,
    lng: 37.6173,
    year: 1957,
    url: "https://furrend.xyz/blog/story-archive/laika-the-dog",
    face: "../assets/images/laika_the_dog.png",
  },
  {
    id: "lady-greyhound",
    name: "Lady Greyhound",
    blurb: "The Greyhound Bus Company's spokesdog who crossed America",
    place: "Clay Center, Kansas",
    lat: 39.2983,
    lng: -97.125,
    year: 1957,
    url: "https://furrend.xyz/lady-greyhound",
    face: "../assets/images/lady-greyhound/portrait.webp",
  },
  {
    id: "slippery",
    name: "Slippery",
    blurb: "The runaway sea lion who crossed an international border",
    place: "London, Ontario",
    lat: 42.9849,
    lng: -81.2453,
    year: 1958,
    url: "https://furrend.xyz/blog/story-archive/slippery-the-sea-lion",
    face: "../assets/images/slippery_the_sea_lion.png",
  },
  {
    id: "sam-fire-pole",
    name: "Sam",
    blurb: "The Long Beach firehouse cat who slid down the pole",
    place: "Long Beach, California",
    lat: 33.7701,
    lng: -118.1937,
    year: 1958,
    url: "https://furrend.xyz/blog/story-archive/sam-the-cat-who-slid-down-the-fire-pole",
    face: "../assets/images/sam_the_cat.webp",
  },
  {
    id: "arthur-tv",
    name: "Arthur",
    blurb: "The paw-dipping TV cat of 1960s Britain",
    place: "London, England",
    lat: 51.52,
    lng: -0.1,
    year: 1966,
    url: "https://furrend.xyz/blog/story-archive/arthur-the-tv-cat",
    face: "../assets/images/arthur_the_tv_cat.png",
  },
  {
    id: "ham",
    name: "Ham",
    blurb: "The astrochimp who flew before the astronauts",
    place: "Cape Canaveral, Florida",
    lat: 28.3922,
    lng: -80.6077,
    year: 1961,
    url: "https://furrend.xyz/blog/story-archive/ham-the-astrochimp",
    face: "../assets/images/ham_the_chimp.png",
  },
  {
    id: "andre",
    name: "Andre",
    blurb: "The harbor seal who chose Rockport, Maine",
    place: "Rockport, Maine",
    lat: 44.1845,
    lng: -69.075,
    year: 1962,
    url: "https://furrend.xyz/blog/story-archive/andre-the-seal-who-chose-a-town",
    face: "../assets/images/andre_the_seal.png",
  },
  {
    id: "towser",
    name: "Towser",
    blurb: "The world’s greatest mouser of Glenturret Distillery",
    place: "Crieff, Scotland",
    lat: 56.372,
    lng: -3.838,
    year: 1963,
    url: "https://furrend.xyz/blog/story-archive/towser-the-worlds-greatest-mouser",
    face: "../assets/images/towser_the_cat.png",
  },
  {
    id: "petra",
    name: "Petra",
    blurb: "Blue Peter’s dog who received 60,000 letters",
    place: "London, England",
    lat: 51.5186,
    lng: -0.143,
    year: 1962,
    url: "https://furrend.xyz/blog/story-archive/petra-and-the-60000-letters",
    face: "../assets/images/petra_the_tv_dog.png",
  },
  {
    id: "felicette",
    name: "Félicette",
    blurb: "The Paris street cat who touched space and came home",
    place: "Paris, France",
    lat: 48.8566,
    lng: 2.3522,
    year: 1963,
    url: "https://furrend.xyz/blog/story-archive/felicette-the-cat-who-touched-space",
    face: "../assets/images/felicette_the_cat.png",
  },
  {
    id: "pickles",
    name: "Pickles",
    blurb: "The collie who found the stolen World Cup trophy",
    place: "London, England",
    lat: 51.46,
    lng: -0.12,
    year: 1966,
    url: "https://furrend.xyz/blog/story-archive/pickles-the-dog-who-found-the-world-cup-trophy",
    face: "../assets/images/pickles_the_dog.png",
  },
  {
    id: "beeps",
    name: "Beeps",
    blurb: "The ship’s cat who wouldn’t leave RRS Discovery",
    place: "London, England",
    lat: 51.5055,
    lng: -0.0754,
    year: 1968,
    url: "https://furrend.xyz/blog/story-archive/beeps-the-cat-who-wouldnt-leave-rrs-discovery",
    face: "../assets/images/beeps_ships_cat_of_discovery.webp",
  },
  {
    id: "nasa-cat",
    name: "NASA’s falling cats",
    blurb: "The year researchers studied how cats twist in mid-air",
    place: "United States",
    lat: 38.8833,
    lng: -77.0167,
    year: 1969,
    url: "https://furrend.xyz/blog/story-archive/the-year-nasa-learned-how-to-fall-like-a-cat",
  face: "../assets/images/the_falling_cat.png",
  },
  {
    id: "hoover",
    name: "Hoover",
    blurb: "The talking seal with a Maine accent",
    place: "Boston, Massachusetts",
    lat: 42.3592,
    lng: -71.0499,
    year: 1971,
    url: "https://furrend.xyz/blog/story-archive/hoover-the-seal-who-sounded-human",
    face: "../assets/images/hoover_the_talking_seal.png",
  },
  {
    id: "buddy",
    name: "Buddy",
    blurb: "The Carson City wonder dog who drove a Model T",
    place: "Carson City, Nevada",
    lat: 39.1638,
    lng: -119.7674,
    year: 1974,
    url: "https://furrend.xyz/blog/story-archive/buddy-the-dog-who-drove-a-model-t",
    face: "../assets/images/buddy_the_wonderdog.webp",
  },
  {
    id: "beerbohm",
    name: "Beerbohm",
    blurb: "The West End theatre cat who walked onstage mid-play",
    place: "London, England",
    lat: 51.5115,
    lng: -0.133,
    year: 1976,
    url: "https://furrend.xyz/blog/story-archive/beerbohm-the-theatre-cat",
    face: "../assets/images/beerbohm_the_theatre_cat.png",
  },
  {
    id: "smudge",
    name: "Smudge",
    blurb: "The museum cat who joined a trade union",
    place: "Glasgow, Scotland",
    lat: 55.856,
    lng: -4.247,
    year: 1979,
    url: "https://furrend.xyz/blog/story-archive/smudge-the-museum-cat-who-joined-a-trade-union",
    face: "../assets/images/smudge_the_cat.webp",
  },
  {
    id: "baker-taylor",
    name: "Baker & Taylor",
    blurb: "The Nevada library cats who became national mascots",
    place: "Minden, Nevada",
    lat: 38.9541,
    lng: -119.7657,
    year: 1983,
    url: "https://furrend.xyz/baker-and-taylor",
    face: "../assets/images/baker-and-taylor/studio.webp",
  },
  {
    id: "katta-kun",
    name: "Katta-kun",
    blurb: "The pelican who flew to kindergarten in Ube",
    place: "Ube, Japan",
    lat: 33.9517,
    lng: 131.2467,
    year: 1985,
    url: "https://furrend.xyz/blog/story-archive/katta-kun-the-pelican-who-went-to-kindergarten",
    face: "../assets/images/katta_kun_the_pelican.webp",
  },
  {
    id: "lala",
    name: "Lala",
    blurb: "Japan’s penguin who walked to the fish market with a backpack",
    place: "Shibushi, Japan",
    lat: 31.4667,
    lng: 131.1,
    year: 1986,
    url: "https://furrend.xyz/blog/lala-the-penguin",
    face: "../assets/images/lala-the-penguin.png",
  },
  {
    id: "koko",
    name: "Koko",
    blurb: "The gorilla who raised kittens as her own",
    place: "Woodside, California",
    lat: 37.4299,
    lng: -122.2539,
    year: 1984,
    url: "https://furrend.xyz/blog/koko-the-gorilla-who-raised-kittens-as-her-own",
    face: "../assets/images/koko-the-gorilla.png",
  },
  {
    id: "tipper",
    name: "Tipper",
    blurb: "The cat who called 911",
    place: "Tampa, Florida",
    lat: 27.9506,
    lng: -82.4572,
    year: 1996,
    url: "https://furrend.xyz/blog/story-archive/tipper-the-cat-who-called-911",
    face: "../assets/images/tipper_the_cat.webp",
  },
  {
    id: "osborne",
    name: "Osborne",
    blurb: "The Royal Court Theatre cat",
    place: "London, England",
    lat: 51.4924,
    lng: -0.1567,
    year: 1996,
    url: "https://furrend.xyz/blog/story-archive/osborne-the-royal-court-theatre-cat",
    face: "../assets/images/osborne_royal_court.webp",
  },
  {
    id: "animals-911",
    name: "Animals of 9/11",
    blurb: "Guide dogs, search dogs, and the animals of September 11",
    place: "New York City",
    lat: 40.7115,
    lng: -74.0134,
    year: 2001,
    url: "https://furrend.xyz/blog/remembering-the-animals-of-911",
    face: "../assets/images/remembering_the_animals_of_911.webp",
  },
  {
    id: "larry",
    name: "Larry",
    blurb: "Chief Mouser at 10 Downing Street",
    place: "London, England",
    lat: 51.5034,
    lng: -0.1276,
    year: 2011,
    url: "https://furrend.xyz/larry-the-cat",
    face: "../assets/images/larry/david_larry.png",
  },
  {
    id: "lewis",
    name: "Lewis",
    blurb: "The Connecticut cat put under house arrest",
    place: "Fairfield County, Connecticut",
    lat: 41.2,
    lng: -73.3,
    year: 2006,
    url: "https://furrend.xyz/blog/story-archive/lewis-the-cat-who-was-put-under-house-arrest",
    face: "../assets/images/lewis_the_cat.png",
  },
  {
    id: "bobbi-bob",
    name: "Bobbi & Bob Cat",
    blurb: "The dog and blind cat who survived Hurricane Katrina together",
    place: "New Orleans, Louisiana",
    lat: 29.9511,
    lng: -90.0715,
    year: 2006,
    url: "https://furrend.xyz/blog/bobbi-and-bob-the-cat",
    face: "../assets/images/bobbie_bob.webp",
  },
  {
    id: "grape-kun",
    name: "Grape-kun",
    blurb: "The penguin who fell in love with a cardboard cutout",
    place: "Tobu Zoo, Japan",
    lat: 36.0,
    lng: 139.7,
    year: 2017,
    url: "https://furrend.xyz/blog/grape-kun-the-penguin",
    face: "../assets/images/grape-kun-the-penguin.png",
  },
  {
    id: "achilles",
    name: "Achilles",
    blurb: "The Hermitage museum cat who predicted the World Cup",
    place: "St. Petersburg, Russia",
    lat: 59.9398,
    lng: 30.3146,
    year: 2018,
    url: "https://furrend.xyz/blog/the-museum-cat-who-became-a-world-cup-oracle",
    face: "../assets/images/achilles_the_cat.png",
  },
  {
    id: "minerva",
    name: "Minerva",
    blurb: "The bookstore cat who hired herself in Rome",
    place: "Rome, Italy",
    lat: 41.8955,
    lng: 12.4823,
    year: 2023,
    url: "https://furrend.xyz/blog/minerva-the-bookstore-cat-of-rome",
    face: "../assets/images/minerva_the_bookstore_cat.png",
  },
  {
    id: "reg",
    name: "Reggie",
    blurb: "The chaos monster beside a Cold War historian",
    place: "Oxford, England",
    lat: 51.752,
    lng: -1.2577,
    year: 2024,
    url: "https://furrend.xyz/blog/fiona-bowler-from-cold-war-history-to-reg-the-cat",
    face: "../assets/images/atlas/reggie.png",
  },
  {
    id: "bodega",
    name: "Bodega cats",
    blurb: "New York’s working cats of the corner store",
    place: "New York City",
    lat: 40.73,
    lng: -73.99,
    year: 2026,
    url: "https://furrend.xyz/blog/creators/bodega-cats-of-new-york",
    face: "../assets/images/bodega_cats_of_new_york.png",
  },
  {
    id: "mariah",
    name: "Mariah",
    blurb: "The Rosemary Branch theatre pub cat",
    place: "London, England",
    lat: 51.542,
    lng: -0.085,
    year: 2026,
    url: "https://furrend.xyz/mariah",
    face: "../assets/images/mariah_at_the_rosemary_branch.png",
  },
  {
    id: "neil",
    name: "Neil",
    blurb: "The elephant seal who keeps coming home to Tasmania",
    place: "Dunalley, Tasmania",
    lat: -42.89,
    lng: 147.8,
    year: 2026,
    url: "https://furrend.xyz/blog/neil-the-seal",
    face: "../assets/images/neil_the_seal.webp",
  },
  {
    id: "ravi",
    name: "Ravi",
    blurb: "The Devon Rex who goes to work at the Pennsylvania Capitol",
    place: "Harrisburg, Pennsylvania",
    lat: 40.264,
    lng: -76.8839,
    year: 2026,
    url: "https://furrend.xyz/ravi-benham",
    face: "../assets/images/ravi-benham/portrait.webp",
  },
  {
    id: "jimothy",
    name: "Jimothy",
    blurb: "Seattle’s short-spine raccoon and summer mascot",
    place: "Seattle, Washington",
    lat: 47.6062,
    lng: -122.3321,
    year: 2026,
    url: "https://furrend.xyz/jimothy",
    face: "../assets/images/jimothy.webp",
  },
  {
    id: "ophelias-books",
    name: "Ophelia’s Books cats",
    blurb: "Boris and Arkady, the resident cats of a Seattle bookstore",
    place: "Seattle, Washington",
    lat: 47.651,
    lng: -122.35,
    year: 2026,
    url: "https://furrend.xyz/blog/the-cats-of-ophelias-books",
    face: "../assets/images/ophelias_books.webp",
  },
  {
    id: "cupboard-maker",
    name: "Cupboard Maker Books cats",
    blurb: "The Enola bookstore where cats roam among 125,000 books",
    place: "Enola, Pennsylvania",
    lat: 40.2901,
    lng: -76.9344,
    year: 2026,
    url: "https://furrend.xyz/blog/cupboard-maker-books-cat-bookstore",
    face: "../assets/images/cupboard_maker_books.webp",
  },
  {
    id: "us-open",
    name: "US Open animals",
    blurb: "Dogs, pups, and unexpected visitors around tennis’s New York fortnight",
    place: "Queens, New York",
    lat: 40.75,
    lng: -73.845,
    year: 2026,
    url: "https://furrend.xyz/blog/at-the-us-open",
    face: "../assets/images/us_open.webp",
  },
  {
    id: "roger",
    name: "Roger",
    blurb: "Salcombe’s unofficial security gull",
    place: "Salcombe, Devon, England",
    lat: 50.2374,
    lng: -3.7687,
    year: 2026,
    url: "https://furrend.xyz/roger-the-seagull",
    face: "../assets/images/roger/banner.jpg",
  },
  {
    id: "churchill-pub",
    name: "Churchill",
    blurb: "The pub cat of the Old Eagle in Camden",
    place: "London, England",
    lat: 51.539,
    lng: -0.143,
    year: 2014,
    url: "https://furrend.xyz/blog/churchill-the-pub-cat-of-the-old-eagle-club",
    face: "../assets/images/Churchill_old_eagle_pub.webp",
  },
  {
    id: "von-arnim-dogs",
    name: "Elizabeth von Arnim’s dogs",
    blurb: "Fourteen dogs, and a memoir that insisted it wasn’t an autobiography",
    place: "Switzerland",
    lat: 46.318,
    lng: 7.523,
    year: 1936,
    url: "https://furrend.xyz/people/elizabeth-von-arnim-and-her-dogs",
    face: "../assets/images/elizabeth-von-arnim-dogs/ingulf-with-daughter-2.jpg",
  },
  {
    id: "billy-raf",
    name: "Billy",
    blurb: "Wing Commander William Goat, D.S.O. of No. 609 Squadron",
    place: "RAF Manston, Kent",
    lat: 51.342,
    lng: 1.346,
    year: 1943,
    url: "https://furrend.xyz/blog/story-archive/billy-the-raf-goat-john-steinbeck-wrote-about",
    face: "../assets/images/billy_the_goat.webp",
  },
  {
    id: "blackie-post-office",
    name: "Blackie",
    blurb: "Britain’s last Post Office Headquarters cat",
    place: "London, England",
    lat: 51.516,
    lng: -0.0915,
    year: 1979,
    url: "https://furrend.xyz/blog/story-archive/blackie-britains-last-post-office-cat",
    face: "../assets/images/blackie_the_post_office_cat.webp",
  },
  {
    id: "browser-library",
    name: "Browser",
    blurb: "The library cat of White Settlement — hired for life",
    place: "White Settlement, Texas",
    lat: 32.7596,
    lng: -97.4584,
    year: 2016,
    url: "https://furrend.xyz/blog/browser-the-library-cat-for-life",
    face: "../assets/images/browser_the_library_cat.webp",
  },
  {
    id: "crescent-hotel-cats",
    name: "Crescent Hotel cats",
    blurb: "For more than 50 years, cats have found their way to the Crescent",
    place: "Eureka Springs, Arkansas",
    lat: 36.4097,
    lng: -93.7379,
    year: 2026,
    url: "https://furrend.xyz/blog/crescent-hotel-cats",
    face: "../assets/images/crescent_hotel_cats.webp",
  },
];
